import { WebhookPayloadsGetRequestParams } from "@lib/core";

export interface WebhookPayloadDefaultParams extends WebhookPayloadsGetRequestParams { }
export class WebhookPayloadDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "created_at.desc";
  }
}